import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { Component } from '../component';
export default (function (Origin) {
  return (
    /*#__PURE__*/
    function (_Component) {
      _inherits(_class, _Component);

      var _super = _createSuper2(_class);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _super.call(this, props);
        _this.state = {
          text: ''
        };
        _this.handleFilter = _this.handleFilter.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(_class, [{
        key: "getData",
        value: function getData() {
          var _this2 = this;

          var _this$props = this.props,
              onFilter = _this$props.onFilter,
              data = _this$props.data,
              index = _this$props.index;
          if (!onFilter || !this.state.text) return data;
          return data.filter(function (d) {
            return onFilter(_this2.state.text, d, !index);
          });
        }
      }, {
        key: "handleFilter",
        value: function handleFilter(text) {
          var _this$props2 = this.props,
              onSearch = _this$props2.onSearch,
              index = _this$props2.index;
          if (onSearch) onSearch(text, !index);
          this.setState({
            text: text
          });
        }
      }, {
        key: "render",
        value: function render() {
          var onFilter = this.props.onFilter;
          var data = this.getData();
          var filter = onFilter ? this.handleFilter : undefined;
          return (
            /*#__PURE__*/
            React.createElement(Origin, Object.assign({}, this.props, {
              onFilter: filter,
              filterText: this.state.text,
              data: data
            }))
          );
        }
      }]);

      return _class;
    }(Component)
  );
});